/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkWebPushNotificationTokenDto } from '../models/work-web-push-notification-token-dto';

@Injectable({ providedIn: 'root' })
export class WorkPushNotificationTokensV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pushNotificationTokensV2ControllerRegisterWebToken()` */
  static readonly PushNotificationTokensV2ControllerRegisterWebTokenPath = '/v2/push-notification-tokens/web';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pushNotificationTokensV2ControllerRegisterWebToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pushNotificationTokensV2ControllerRegisterWebToken$Response(
    params: {
      body: WorkWebPushNotificationTokenDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPushNotificationTokensV2Service.PushNotificationTokensV2ControllerRegisterWebTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pushNotificationTokensV2ControllerRegisterWebToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pushNotificationTokensV2ControllerRegisterWebToken(
    params: {
      body: WorkWebPushNotificationTokenDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.pushNotificationTokensV2ControllerRegisterWebToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pushNotificationTokensV2ControllerUnregisterWebToken()` */
  static readonly PushNotificationTokensV2ControllerUnregisterWebTokenPath = '/v2/push-notification-tokens/web/unregister';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pushNotificationTokensV2ControllerUnregisterWebToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pushNotificationTokensV2ControllerUnregisterWebToken$Response(
    params: {
      body: WorkWebPushNotificationTokenDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPushNotificationTokensV2Service.PushNotificationTokensV2ControllerUnregisterWebTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pushNotificationTokensV2ControllerUnregisterWebToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pushNotificationTokensV2ControllerUnregisterWebToken(
    params: {
      body: WorkWebPushNotificationTokenDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.pushNotificationTokensV2ControllerUnregisterWebToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
